import React from "react";

// ConfirmDialog component with Tailwind CSS
function ConfirmDialog({ message, onConfirm, onCancel }) {
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-gray-950/50 px-4 backdrop-blur-sm">
      <div className="w-full max-w-sm rounded-md border border-slate-200 bg-white p-5 text-center shadow-xl">
        <p className="mb-5 text-base font-bold text-gray-800">{message}</p>
        <div className="flex justify-center gap-3">
          <button
            type="button"
            className="inline-flex min-h-10 items-center justify-center rounded-md bg-violet-600 px-6 py-2 text-sm font-bold text-white shadow-sm transition hover:bg-violet-700 focus:outline-none focus:ring-2 focus:ring-violet-500 focus:ring-offset-2"
            onClick={onConfirm}
          >
            Yes
          </button>
          <button
            type="button"
            className="inline-flex min-h-10 items-center justify-center rounded-md bg-white px-6 py-2 text-sm font-bold text-gray-700 shadow-sm ring-1 ring-slate-200 transition hover:bg-slate-50 focus:outline-none focus:ring-2 focus:ring-slate-300 focus:ring-offset-2"
            onClick={onCancel}
          >
            No
          </button>
        </div>
      </div>
    </div>
  );
}

export default ConfirmDialog;
